import { render } from "./ErrorLayout.vue?vue&type=template&id=6d68553f&ts=true"
import script from "./ErrorLayout.vue?vue&type=script&lang=ts"
export * from "./ErrorLayout.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__